const DB_NAME = 'ordersdb';
const DB_VERSION = 1;
let DB;



export async function getDb() {
    return new Promise((resolve, reject) => {
        if (DB) { return resolve(DB); }
        let request = window.indexedDB.open(DB_NAME, DB_VERSION);
        request.onerror = e => {
            console.log('Error opening db', e);
            reject('Error');
        };
        request.onsuccess = e => {
            DB = e.target.result;
            resolve(DB);
        };
        request.onupgradeneeded = e => {
            console.log('onupgradeneeded');
            let db = e.target.result;
            db.createObjectStore("orderLines", { autoIncrement: true, keyPath: 'id' });
        };
    });
}

export async function deleteOrders() {
    let db = await getDb();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readwrite');
        trans.oncomplete = () => {
            resolve();
        };
        let store = trans.objectStore('orderLines');
        store.clear();
    });
}

export async function deleteOrder(order) {
    let db = await getDb();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readwrite');
        trans.oncomplete = () => {
            resolve();
        };
        let store = trans.objectStore('orderLines');
        store.delete(order.id);
    });
}

export async function getOrders() {
    let db = await getDb();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readonly');
        trans.oncomplete = () => {
            resolve(orders);
        };
        let store = trans.objectStore('orderLines');
        let orders = [];
        store.openCursor().onsuccess = e => {
            let cursor = e.target.result;
            if (cursor) {
                orders.push(cursor.value)
                cursor.continue();
            }
        };
    });
}

export async function saveOrders(orders) {
    let db = await getDb();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readwrite');
        trans.oncomplete = () => {
            resolve();
        };
        let store = trans.objectStore('orderLines');
        orders.forEach(element => {
            // if (element.No > 0)
                store.put(element);
        });
    });
}

export async function saveOrder(order) {
    let db = await getDb();
    let cmds = await getOrders();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readwrite');
        trans.oncomplete = () => {
            resolve();
        };
        let store = trans.objectStore('orderLines');
        cmds.forEach(element => {
            if (element.No == order.No)
                deleteOrder(element);
        });
        store.put(order);
    });
}



export async function getOrderCount() {
    let db = await getDb();
    return new Promise(resolve => {
        let trans = db.transaction(['orderLines'], 'readonly');
        trans.oncomplete = () => {
            resolve(nb);
        };
        let store = trans.objectStore('orderLines');
        let nb = store.count();
    });
}